import { render, staticRenderFns } from "./TableNoData.vue?vue&type=template&id=0524d9bd"
import script from "./TableNoData.vue?vue&type=script&lang=js"
export * from "./TableNoData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports